<template>
  <div>
    <div
      class="modal fade"
      id="pdfSelector"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pdfSelectorLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container">
              <div class="row">
                <div class="col-auto my-auto">
                  <form @submit.prevent class="form-inline">
                    <div class="form-group mr-3">
                      <input
                        type="text"
                        v-model="altText"
                        class="form-control"
                        placeholder="Alt Text for Selected PDF"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="titleText"
                        class="form-control"
                        placeholder="Add a title to the PDF"
                      />
                    </div>
                  </form>
                </div>
                <div class="col-auto my-auto ml-auto">
                  <button class="btn btn-light btn-sm mr-3" @click="upLevel">
                    <i class="fas fa-level-up"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-light btn-sm"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-body" id="dropzone-area" style="min-height: 40vh">
            <div class="row" v-show="urlError">
              <div class="col">
                <p
                  class="alert alert-danger"
                >Uh oh, looks like there is an issue with the URL you are trying to fetch files from</p>
              </div>
            </div>
            <div class="busy-loader text-center my-5" v-if="busy">
              <i class="fas fa-spinner fa-spin fa-4x text-primary"></i>
            </div>
            <div v-else>
              <div class="row">
                <folder
                  v-for="(folder, key) in folders"
                  :folder="folder"
                  :key="key"
                  style="cursor:pointer"
                  @clicked="folderClicked"
                ></folder>
              </div>
              <hr />
              <div class="row">
                <div class="col-2">
                  <div class="card">
                    <div class="card-body">
                      <i class="fas fa-star"></i>
                    </div>
                  </div>
                </div>
                <file v-for="(file, key) in files" :file="file" :key="key" @selected="choosePdf"></file>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0">
            <div class="container">
              <div class="row pagination">
                <div class="col my-auto">
                  <button
                    class="btn btn-light btn-sm mr-2"
                    @click="fetchFiles(pagination.first_page_url)"
                    :disabled="!pagination.first_page_url"
                  >First Page</button>
                  <button
                    class="btn btn-light btn-sm"
                    @click="fetchFiles(pagination.prev_page_url)"
                    :disabled="!pagination.prev_page_url"
                  >
                    <i class="fas fa-arrow-left mr-2"></i>Previous
                  </button>
                </div>
                <div class="col my-auto text-center">
                  <p class="mb-0">Page {{pagination.current_page}} of {{pagination.last_page}}</p>
                </div>
                <div class="col my-auto text-right">
                  <button
                    class="btn btn-light btn-sm"
                    @click="fetchFiles(pagination.next_page_url)"
                    :disabled="!pagination.next_page_url"
                  >
                    <i class="fas fa-arrow-right mr-2"></i>Next
                  </button>
                  <button
                    class="btn btn-light btn-sm ml-2"
                    @click="fetchFiles(pagination.last_page_url)"
                    :disabled="!pagination.last_page_url"
                  >Last Page</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Folder from "./image-selector-partials/Folder";
import File from "./image-selector-partials/File";
const axios = require("axios");

export default {
  props: ["filesUrl"],
  data() {
    return {
      imageUrl: "",
      folders: [],
      files: [],
      busy: false,
      urlError: false,
      altText: "",
      titleText: "",
      pagination: {},
      currentFolder: ""
    };
  },
  mounted() {
    $("#imageSelector").modal("show");
    var myDropzone = new Dropzone("#dropzone-area", {
      url: "/crm/blog/images/upload"
    });

    myDropzone.on("success", (file, response) => {
      $(".dz-preview").hide();
      this.currentFolder = response.url;
      this.fetchFiles();
    });

    $("#imageSelector").on("hide.bs.modal", e => {
      this.$emit("close");
    });
    this.fetchFiles();
  },
  methods: {
    folderClicked(folder) {
      this.currentFolder = this.currentFolder + "/" + folder;
      this.fetchFiles();
    },
    upLevel() {
      this.currentFolder = this.currentFolder.substring(
        0,
        this.currentFolder.lastIndexOf("/")
      );
      if (this.currentFolder.includes("/")) {
        this.fetchFiles();
      } else {
        this.currentFolder = "";
        this.fetchFiles();
      }
    },
    fetchFiles(pageUrl) {
      this.busy = true;
      var url = pageUrl ? pageUrl : this.filesUrl;

      axios
        .post(url, {
          folder: this.currentFolder
        })
        .then(({ data }) => {
          this.makePagination(data.files);
          this.folders = data.folders;
          this.files = data.files.data;
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.urlError = true;
          }
        })
        .finally(() => {
          this.busy = false;
        });
    },
    makePagination: function(data) {
      let pagination = {
        current_page: data.current_page,
        last_page: data.last_page,
        first_page_url: this.filesUrl + data.first_page_url,
        last_page_url: this.filesUrl + data.last_page_url,
        next_page_url: this.filesUrl + data.next_page_url,
        prev_page_url: this.filesUrl + data.prev_page_url
      };
      this.pagination = pagination;
    },
    choosePdf(data) {
      var data = {
        url: data.url,
        alt: this.altText,
        title: this.titleText
      };
      this.$emit("selected", data);
      $("#imageSelector").modal("hide");
    }
  },
  components: {
    File,
    Folder
  }
};
</script>

<style>
</style>